(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  /* Story photo: day -> night scrubbed by scroll, not fired once. The night
   * frame's opacity follows where the block sits in the viewport - 0 when its
   * top is still in the lower third, 1 once it has travelled 60% of its own
   * height further up - and it reverses when you scroll back. (An
   * IntersectionObserver version fired on load on tall screens; Ice wanted
   * it tied to the act of scrolling, like the lights-out toggle.) */
  (function () {
    var scene = document.querySelector('[data-abt-scene]');
    var night = scene && scene.querySelector('.abt-story__photo-img--night');
    if (!scene || !night) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = scene.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var start = vh * 0.35;
      var travel = Math.max(1, r.height * 0.6);
      var p = ((vh - r.top) - start) / travel;
      p = Math.max(0, Math.min(1, p));
      night.style.opacity = p.toFixed(3);
      scene.classList.toggle('is-night', p >= 0.5);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ahero]');
    if (!root) return;
    var input = root.querySelector('[data-ahero-input]');
    var frames = root.querySelectorAll('.ahero__bg');

    // ?shot=1 — full-page screenshot rigs use a very tall window, which would
    // stretch a 100svh hero to the whole capture. Cap it for those runs only.
    if (/[?&]shot=1/.test(location.search)) root.style.minHeight = '900px';

    // Only letters, accents, spaces, hyphens and apostrophes — same set the
    // product page accepts, so nothing is silently dropped on handoff.
    input.addEventListener('input', function () {
      var clean = input.value.replace(/[^A-Za-zÀ-ɏ' -]/g, '');
      if (clean !== input.value) input.value = clean;
    });

    // Experiment hero_path (lumn-analytics.liquid assigns window.lumnExp):
    //   A / off → the Teddy customizer with the name (wow first)
    //   B       → the grid, every tile carrying the name (browse first)
    var form = root.querySelector('[data-ahero-form]');
    var variant = window.lumnExp || 'off';
    // (Liquid never renders inside a javascript block — the grid URL rides on a data attribute)
    if (variant === 'B' && form.dataset.gridUrl) form.setAttribute('action', form.dataset.gridUrl);
    form.addEventListener('submit', function () {
      var n = input.value.trim();
      if (window.lumnName) window.lumnName(n);
      if (window.lumnTrack) window.lumnTrack('hero_submit', { name_length: n.length, path: variant === 'B' ? 'grid' : 'customizer' });
    });

    // The light on the wall cycles through the six named lights. Frames are
    // pixel-identical rooms, so the crossfade reads as the light changing.
    // 4.2s per light, offset from every other cycler on the site; a still
    // for anyone who prefers reduced motion.
    if (frames.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var i = 0;
      setInterval(function () {
        frames[i].classList.remove('is-active');
        i = (i + 1) % frames.length;
        frames[i].classList.add('is-active');
      }, 4200);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity steppers: adjust the input, then submit the cart form so totals
  // refresh. No-JS fallback: type a number and press "Update".
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('.cart-page__form');
    if (!form) return;
    form.querySelectorAll('[data-qty-wrapper]').forEach(function (wrap) {
      var input = wrap.querySelector('.cart-page__qty-input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus  = wrap.querySelector('[data-qty-plus]');
      function bump(delta) {
        var v = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, v + delta);
        form.submit();
      }
      if (minus) minus.addEventListener('click', function () { bump(-1); });
      if (plus)  plus.addEventListener('click',  function () { bump(1);  });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Sort select — navigate on change */
  (function () {
    const sel = document.getElementById('col-sort-select');
    if (!sel) return;
    sel.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  })();

  /* Grid: load more / show all / search — one shared page loader.
     The fetched page renders the promo card too, so appends must exclude
     .product-card--promo or every load duplicates it; new cards are
     inserted BEFORE the promo card so it stays last in the grid. */
  (function () {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const loadMoreBtn = document.getElementById('load-more-btn');
    const showAllBtn = document.getElementById('show-all-btn');
    const searchInput = document.getElementById('col-search-input');
    const emptyMsg = document.querySelector('[data-search-empty]');
    const resultCount = document.querySelector('.col-result-count');
    const total = resultCount ? parseInt(resultCount.dataset.total, 10) : 0;

    let nextUrl = loadMoreBtn ? loadMoreBtn.dataset.url : null;
    let loadingAll = null;
    let onPageLoaded = null; /* set by search so streamed-in cards are filtered immediately */

    const cards = () => grid.querySelectorAll('[data-product-card]:not(.product-card--promo)');
    const promo = () => grid.querySelector('.product-card--promo');

    function updateShownCount() {
      const wrap = document.querySelector('[data-load-more]');
      if (!wrap) return;
      if (!nextUrl) { wrap.remove(); return; }
      const el = wrap.querySelector('.col-load-more__count');
      if (el) el.textContent = 'Showing ' + cards().length + ' of ' + total;
    }

    async function loadNextPage() {
      if (!nextUrl) return;
      const res = await fetch(nextUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const p = promo();
      doc.querySelectorAll('[data-product-card]:not(.product-card--promo)').forEach(c => {
        if (p) { grid.insertBefore(c, p); } else { grid.appendChild(c); }
      });
      const nextBtn = doc.getElementById('load-more-btn');
      nextUrl = nextBtn ? nextBtn.dataset.url : null;
      updateShownCount();
      if (onPageLoaded) onPageLoaded();
    }

    function loadAll() {
      if (!loadingAll) {
        loadingAll = (async () => { while (nextUrl) await loadNextPage(); })();
        loadingAll.catch(() => { loadingAll = null; });
      }
      return loadingAll;
    }

    if (loadMoreBtn) {
      const idleHtml = loadMoreBtn.innerHTML;
      loadMoreBtn.addEventListener('click', async function () {
        this.disabled = true;
        this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="animation:spin .8s linear infinite"><path d="M21 2v6h-6"/><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M3 22v-6h6"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/></svg> Loading…';
        try { await loadNextPage(); } catch (err) { /* restore below */ }
        if (this.isConnected) { this.disabled = false; this.innerHTML = idleHtml; }
      });
    }

    if (showAllBtn) {
      showAllBtn.addEventListener('click', function () {
        const self = this;
        self.disabled = true;
        self.textContent = 'Loading all designs…';
        loadAll().catch(() => {
          self.disabled = false;
          self.textContent = 'Show all ' + total + ' designs';
        });
      });
    }

    /* Search — instant client-side name filter. Typing pulls in any
       not-yet-loaded pages first so the filter always covers all designs. */
    if (searchInput) {
      function applyFilter() {
        const q = searchInput.value.trim().toLowerCase();
        let shown = 0;
        cards().forEach(c => {
          const hit = !q || (c.dataset.title || '').indexOf(q) !== -1;
          c.style.display = hit ? '' : 'none';
          if (hit) shown++;
        });
        const p = promo();
        if (p) p.style.display = q ? 'none' : '';
        const wrap = document.querySelector('[data-load-more]');
        if (wrap) wrap.style.display = q ? 'none' : '';
        if (emptyMsg) emptyMsg.hidden = !q || shown > 0;
        if (resultCount) {
          resultCount.textContent = q
            ? shown + ' of ' + total + ' designs'
            : total + (total === 1 ? ' design' : ' designs');
        }
      }
      onPageLoaded = function () { if (searchInput.value.trim()) applyFilter(); };
      searchInput.addEventListener('input', function () {
        if (this.value.trim() && nextUrl) loadAll().then(applyFilter).catch(() => {});
        applyFilter();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-lumn-cycler]');
    if (!wrap) return;

    var imgs = wrap.querySelectorAll('.lumn-plate__img--cycle');
    if (imgs.length < 2) {
      if (imgs[0]) imgs[0].classList.add('is-active');
      return;
    }

    /* Every frame is a personalized light now, so there is no "the
     * personalized one" to settle on — loop continuously instead. */
    var i = 0;
    imgs[0].classList.add('is-active');
    setInterval(function () {
      imgs[i].classList.remove('is-active');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-active');
    }, 3200);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["day-night"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dnight').forEach(function (sec) {
      var btn = sec.querySelector('[data-dnight-toggle]');
      if (!btn) return;

      /* Copy swapping is pure CSS (stacked day/night states) — JS only
         flips the state class and the accessible pressed state. */
      btn.addEventListener('click', function () {
        var night = sec.classList.toggle('is-night');
        btn.setAttribute('aria-pressed', night ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  /* Highlight active sidebar link on scroll */
  (function () {
    const sidebarLinks = document.querySelectorAll('.faq-sidebar__item');
    const sections = document.querySelectorAll('.faq-group');
    if (!sidebarLinks.length || !sections.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          sidebarLinks.forEach(link => {
            link.classList.toggle('faq-sidebar__item--active', link.getAttribute('href') === '#' + id);
          });
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });

    sections.forEach(s => observer.observe(s));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Cart badge. Both add-to-cart paths — the customizer modal and the PDP's
   * blank button — POST to /cart/add.js with no page reload, so the count
   * Liquid rendered at page load goes stale and the customer sees nothing
   * happen. They dispatch 'cart:updated'; the header repaints from the real
   * cart. This theme has no cart drawer, so the badge IS the confirmation. */
  (function () {
    var link  = document.querySelector('[data-cart-link]');
    var badge = link && link.querySelector('[data-cart-count]');
    if (!badge) return;

    function paint(count) {
      badge.textContent = count > 99 ? '99+' : String(count);
      if (count > 0) {
        badge.removeAttribute('hidden');
        badge.classList.remove('is-bumped');
        void badge.offsetWidth; /* reflow, so the animation restarts on a re-add */
        badge.classList.add('is-bumped');
      } else {
        badge.setAttribute('hidden', '');
      }
      link.setAttribute('aria-label', 'Cart (' + count + (count === 1 ? ' item)' : ' items)'));
    }

    function refresh(known) {
      if (typeof known === 'number') { paint(known); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) paint(cart.item_count); })
        .catch(function () { /* keep the last known count rather than lie */ });
    }

    document.addEventListener('cart:updated', function (e) {
      refresh(e && e.detail ? e.detail.item_count : undefined);
    });

    /* Back-button restores from bfcache with the count as it was on the way out. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  })();

  (function () {
    const burger = document.querySelector('.site-header__burger');
    const mobileNav = document.getElementById('site-mobile-nav');
    if (!burger || !mobileNav) return;

    burger.addEventListener('click', function () {
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.setAttribute('aria-hidden', String(isOpen));
      mobileNav.classList.toggle('is-open', !isOpen);
    });

    document.addEventListener('click', function (e) {
      if (!burger.contains(e.target) && !mobileNav.contains(e.target)) {
        burger.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        mobileNav.classList.remove('is-open');
      }
    });
  })();

  /* "Start with their name": if this page has the hero's name box, go there and
   * put the cursor in it; otherwise the link opens the Teddy customizer. */
  (function () {
    var input = document.querySelector('[data-ahero-input]');
    if (!input) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-header-cta]');
      if (!a) return;
      e.preventDefault();
      var burger = document.querySelector('.site-header__burger[aria-expanded="true"]');
      if (burger) burger.click();                       /* close the mobile menu first */
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
      if (window.lumnTrack) window.lumnTrack('header_cta', { action: 'focus_name_box' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-nsteps-compare]');
    if (!wrap) return;
    var range = wrap.querySelector('.nsteps__compare-range');
    range.addEventListener('input', function () {
      wrap.style.setProperty('--split', range.value + '%');
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* ── Gallery: one visible frame; arrows step, thumbs jump ────────────── */
  (function () {
    var frames = document.querySelectorAll('.main-product__frame');
    if (frames.length < 2) return;
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var gallery = document.querySelector('.main-product__gallery');
    var gi = function (k) { var n = gallery ? parseInt(gallery.getAttribute(k), 10) : NaN; return isNaN(n) ? -1 : n; };
    /* Liquid already painted the start frame (the named hero on a personalizable
     * design); keep the stepper's position in step with it. */
    var current = Math.max(0, gi('data-start-index'));

    function show(idx) {
      current = (idx + frames.length) % frames.length;
      frames.forEach(function (f, i) {
        f.classList.toggle('is-active', i === current);
        var v = f.querySelector && f.querySelector('video');
        if (!v) return;
        if (i === current) {
          /* Selecting the frame is the visitor's "show me" — start it (muted,
           * looping). Never autoplays on page load: the lit photo is frame one. */
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();                    /* nothing plays out of sight */
        }
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
        if (i === current) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    /* caption chip hides while playing, returns when paused/ended */
    frames.forEach(function (f) {
      var v = f.querySelector && f.querySelector('video');
      if (!v) return;
      v.addEventListener('play', function () { f.classList.add('is-playing'); });
      v.addEventListener('pause', function () { f.classList.remove('is-playing'); });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-gallery-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-gallery-next]')) { show(current + 1); return; }
      var btn = e.target.closest('[data-gallery-thumb]');
      if (btn) show(parseInt(btn.getAttribute('data-index'), 10));
    });

    /* Hidden frames are lazy + display:none, so the browser never fetches
     * them until first shown — the first lit->unlit flip stalled on a network
     * round-trip (Ice). Warm them after load: lifting the lazy gate triggers
     * the fetch, decode() pre-rasterizes, and the featured image has already
     * had the bandwidth to itself. */
    function warm() {
      frames.forEach(function (f) {
        if (f.tagName !== 'IMG') return;           /* video frames stay preload=none */
        if (f.loading === 'lazy') f.loading = 'eager';
        if (f.decode) f.decode().catch(function () {});
      });
    }
    if (document.readyState === 'complete') setTimeout(warm, 150);
    else window.addEventListener('load', function () { setTimeout(warm, 150); });

    /* The Blank / Personalized toggle swaps the hero: named photo for Personalized,
     * blank photo for Blank. Only when the design has a named photo. */
    var namedIdx = gi('data-named-index'), blankIdx = gi('data-blank-index');
    window.lumnShowHero = function (personalized) {
      if (namedIdx < 0) return;
      show(personalized ? namedIdx : Math.max(0, blankIdx));
    };
  })();

  document.addEventListener('DOMContentLoaded', function () {

    // ── Config ──────────────────────────────────────────────────────
    var rootEl = document.querySelector('.main-product');
    var ADD_TO_CART_LABEL = rootEl ? (rootEl.dataset.addToCartLabel || 'Add to cart') : 'Add to cart';

    // ── Element refs ────────────────────────────────────────────────
    // The customiser modal (open/close + ADD_TO_CART → cart) is owned by the
    // global snippet (snippets/customizer-modal.liquid). This section only owns
    // the variant selector, price/image swap, and the Blank-variant add-to-cart.
    var launchBtn      = document.getElementById('primary-cta');
    var addCartBtn     = document.getElementById('add-to-cart-btn');
    var ctaHint        = document.getElementById('cta-hint');
    var variantInput   = document.querySelector('[data-variant-id]');
    var priceEl        = document.querySelector('.price-current');
    var comparePriceEl = document.querySelector('.price-compare');

    // ── Variant data ─────────────────────────────────────────────────
    var variantsEl = document.getElementById('product-variants-json');
    var variants   = [];
    try {
      if (variantsEl) variants = JSON.parse(variantsEl.textContent);
    } catch (_) {}

    // ── Helpers ──────────────────────────────────────────────────────
    function isBlank(title) {
      return title.toLowerCase().indexOf('blank') !== -1;
    }

    function showHide(el, visible) {
      if (el) el.style.display = visible ? '' : 'none';
    }

    // Shop money format string, e.g. "$&lcub;&lcub;amount&rcub;&rcub;" (with real curly braces) —
    // stamped onto the section root as data-money-format, because Liquid is
    // not available inside this javascript block. Mirrors Shopify's own
    // formatMoney placeholder handling (amount, amount_no_decimals,
    // amount_with_comma_separator, amount_no_decimals_with_comma_separator,
    // amount_with_apostrophe_separator).
    /* Strip any markup from the format (money_with_currency variants can
     * carry <span> wrappers) — this string lands in textContent, where tags
     * would render literally. */
    var MONEY_FORMAT = ((rootEl && rootEl.dataset.moneyFormat) || ('$' + '{' + '{amount}}')).replace(/<[^>]*>/g, '');

    function formatMoney(cents) {
      var value = parseInt(cents, 10);
      if (isNaN(value)) value = 0;

      function withDelimiters(number, precision, thousands, decimal) {
        var fixed = (number / 100).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }

      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = MONEY_FORMAT.match(placeholder);
      var formatted;

      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          formatted = withDelimiters(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator':
          formatted = withDelimiters(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator':
          formatted = withDelimiters(value, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator':
          formatted = withDelimiters(value, 2, "'", '.'); break;
        default:
          formatted = withDelimiters(value, 2, ',', '.'); break;
      }

      return match ? MONEY_FORMAT.replace(placeholder, formatted) : formatted;
    }

    // ── applyVariant — updates image, price, and buttons ────────────
    function applyVariant(variant) {
      if (!variant) return;

      // 1. Update hidden form variant ID
      if (variantInput) variantInput.value = variant.id;

      // 2. Swap main product image (fade out → swap src → fade in)
      var mainImg = document.getElementById('main-product-img');
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        var rawSrc = variant.featured_image.src;
        // Request a sensible resolution from the Shopify CDN
        var newSrc = rawSrc.indexOf('?') !== -1
          ? rawSrc + '&width=1000'
          : rawSrc + '?width=1000';
        if (mainImg.src !== newSrc) {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = newSrc;
            mainImg.alt = variant.featured_image.alt || variant.title;
            mainImg.style.opacity = '1';
          }, 200);
        }
      }

      // 3. Update displayed price
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // 4. Both CTAs are always visible — the studio is the primary path,
      //    the blank add-to-cart is the quiet secondary. Nothing to toggle.
    }

    // ── Variant option change listener ───────────────────────────────
    var optionInputs = document.querySelectorAll('[data-variant-option]');

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        // Update selected pill style
        document.querySelectorAll('.variant-style__btn').forEach(function (btn) {
          btn.classList.remove('variant-style__btn--selected');
        });
        if (input.parentElement) {
          input.parentElement.classList.add('variant-style__btn--selected');
        }

        // Collect all currently selected option values
        var selected = [];
        optionInputs.forEach(function (opt) {
          if (opt.checked) selected.push(opt.value);
        });

        // Find the matching variant
        var matched = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < selected.length; j++) {
            if (v.options[j] !== selected[j]) { match = false; break; }
          }
          if (match) { matched = v; break; }
        }

        if (matched) applyVariant(matched);
      });
    });

    // ── Apply correct button on initial page load ────────────────────
    var checkedInput = document.querySelector('[data-variant-option]:checked');
    if (checkedInput) {
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ── Add to Cart (AJAX) ───────────────────────────────────────────
    var form = document.getElementById('main-product-form');
    if (form && addCartBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addCartBtn.disabled = true;
        addCartBtn.textContent = 'Adding…';

        // The form is the BLANK path. If the product has a variant whose
        // title contains "Blank", prefer it — otherwise the current variant
        // ships with the "shipped blank" property carried by the hidden input.
        var formData = new FormData(form);
        var blankVariant = null;
        for (var bi = 0; bi < variants.length; bi++) {
          if (isBlank(variants[bi].title)) { blankVariant = variants[bi]; break; }
        }
        if (blankVariant) formData.set('id', blankVariant.id);

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Accept': 'application/json' },
          body:    formData
        })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          /* Repaint the header badge (see snippets/customizer-modal.liquid) —
           * without this a blank add looks like nothing happened at all. */
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        })
        .catch(function (err) {
          console.error('[LightUpMyNight] Add to cart error:', err);
        })
        .finally(function () {
          addCartBtn.disabled    = false;
          addCartBtn.textContent = ADD_TO_CART_LABEL;
        });
      });
    }

    // ── Customiser modal ─────────────────────────────────────────────
    // Open/close and the ADD_TO_CART → /cart/add.js flow are owned solely by
    // the global snippet (snippets/customizer-modal.liquid). The launch button
    // carries [data-open-customizer] + data-customizer-url, so that snippet
    // wires it up automatically.

    // ── Optional name → studio hand-off ─────────────────────────────
    var nameInput = document.getElementById('lumn-name-input');
    var ctaLabel  = document.querySelector('[data-customizer-label]');
    var CTA_BASE  = ctaLabel ? ctaLabel.textContent : '';

    var primaryCta = document.getElementById('primary-cta');
    var ctaIcon    = primaryCta ? primaryCta.querySelector('.primary-cta__icon') : null;
    var modeBtns   = document.querySelectorAll('.pmode__btn');

    /* Blank mode submits the real form; personalized mode falls through to the
     * modal's delegated [data-open-customizer] handler. */
    if (primaryCta) {
      primaryCta.addEventListener('click', function (e) {
        if (mode === 'personalized') return;
        e.preventDefault();
        var f = document.getElementById('main-product-form');
        if (!f) return;
        if (f.requestSubmit) f.requestSubmit();
        else if (addCartBtn) addCartBtn.click();
      });
    }

    /* The Blank / Personalized toggle is the source of truth for the CTA.
     * Typing a name flips it to Personalized (typing IS the act of
     * personalizing); choosing Blank clears the field, so the page can never
     * show a name that won't be made. Two buttons stay in the DOM and exactly
     * one is shown, which keeps the cart form and the customizer contract
     * each wired to their own element. */
    var mode = 'blank';

    function applyMode(next) {
      var changed = next !== mode;
      mode = next;
      if (changed && window.lumnShowHero) window.lumnShowHero(mode === 'personalized');
      modeBtns.forEach(function (b) {
        var on = b.dataset.mode === mode;
        b.classList.toggle('pmode__btn--on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var personalized = mode === 'personalized';

      if (ctaIcon) ctaIcon.hidden = !personalized;

      /* Attach the customizer contract only in personalized mode — the modal
       * binds by delegation on [data-open-customizer], so leaving it on would
       * open the 3D preview from a blank-mode click. */
      if (primaryCta) {
        if (personalized) {
          primaryCta.setAttribute('data-open-customizer', '');
          primaryCta.setAttribute('aria-haspopup', 'dialog');
          primaryCta.setAttribute('aria-controls', 'customizer-modal');
        } else {
          primaryCta.removeAttribute('data-open-customizer');
          primaryCta.removeAttribute('aria-haspopup');
          primaryCta.removeAttribute('aria-controls');
        }
      }

      if (ctaHint) {
        ctaHint.textContent = personalized
          ? (ctaHint.dataset.hintNamed || '')
          : (ctaHint.dataset.hintBlank || '');
      }

      /* Keep the cart variant in step when the product still carries the
       * legacy Blank / Personalized variant pair. */
      if (variantInput && variants.length) {
        for (var i = 0; i < variants.length; i++) {
          var t = variants[i].title.toLowerCase();
          if (personalized ? t.indexOf('personal') !== -1 : t.indexOf('blank') !== -1) {
            variantInput.value = variants[i].id;
            break;
          }
        }
      }

      applyName();
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var next = b.dataset.mode;
        /* Going back to Blank drops the typed name — a name on screen with a
         * blank product in the cart would ship the wrong thing. */
        if (next === 'blank' && nameInput && nameInput.value) {
          nameInput.value = '';
          applyName();
        }
        applyMode(next);
      });
    });

    /* Only characters the lithophane fonts can actually carve. The shipped
     * faces are Latin-Extended, so accents are welcome (Chloé, Léo, Zoë) but
     * emoji, symbols and non-Latin scripts are not — they would reach the
     * studio, fail to render, and the customer would have typed something the
     * product cannot make. Stripping here means the promise on this page is
     * always keepable.
     *
     * maxlength=20 above is the length half of the same promise: W is the
     * widest glyph, and 20 W's exactly fill the panel's name budget, so any
     * 20-character string is guaranteed to fit without the studio silently
     * shortening it. */
    /* Explicit ranges rather than \p{Script=Latin}: no Unicode-property
     * escapes means no engine-support caveat and no escaping traps. Covers
     * ASCII letters, Latin-1 Supplement and Latin Extended-A/B (A-Z, a-z,
     * plus every accent the shipped faces carry), digits, space, apostrophe,
     * hyphen and period. Everything else — emoji, symbols, CJK, Cyrillic — is
     * stripped, because the lithophane fonts cannot carve it and the customer
     * would otherwise type something the product cannot make. */
    var NAME_ALLOWED = /[^A-Za-z\u00C0-\u024F0-9 '.-]/g;

    function sanitizeName() {
      if (!nameInput) return;
      var before = nameInput.value;
      var after  = before.replace(NAME_ALLOWED, '');
      if (after === before) return;
      /* Keep the caret where the typist expects it after a silent strip. */
      var pos = nameInput.selectionStart;
      var removedBeforeCaret = before.slice(0, pos).length
                             - before.slice(0, pos).replace(NAME_ALLOWED, '').length;
      nameInput.value = after;
      try { nameInput.setSelectionRange(pos - removedBeforeCaret, pos - removedBeforeCaret); } catch (_) {}
    }

    function applyName() {
      if (!launchBtn) return;
      sanitizeName();
      var raw = nameInput ? nameInput.value.trim() : '';
      if (raw.length > 0 && mode !== 'personalized') applyMode('personalized');
      if (window.lumnName) window.lumnName(raw);

      // 1. Carry the name into the studio URL (?name=) — the app pre-fills
      //    from it; until it supports the param, it is simply ignored.
      try {
        var u = new URL(launchBtn.dataset.customizerUrl);
        if (raw) { u.searchParams.set('name', raw); } else { u.searchParams.delete('name'); }
        launchBtn.dataset.customizerUrl = u.toString();
      } catch (_) {}

      // 2. Rewrite the CTA with the name, so the button makes the promise. With no
      //    name yet the label follows the mode: Personalized opens the 3D preview,
      //    so it must not say "Add to cart" (it did, before 2026-10-16).
      if (ctaLabel) {
        ctaLabel.textContent = raw
          ? 'Personalize ' + raw.charAt(0).toUpperCase() + raw.slice(1) + '’s light in 3D'
          : (mode === 'personalized'
              ? (ctaLabel.dataset.labelNamed || CTA_BASE)
              : (ctaLabel.dataset.labelBlank || CTA_BASE));
      }
    }

    if (nameInput) {
      nameInput.addEventListener('input', applyName);
      applyName();
    }

    /* Start mode comes from the markup (Personalized since 2026-10-16). Liquid already
     * painted the buttons, label, hint and hero for it; this wires the CTA contract. */
    var pmodeEl = document.querySelector('.pmode');
    if (pmodeEl && pmodeEl.dataset.startMode === 'personalized') applyMode('personalized');

    // Opening the studio = the personalized path. If the product carries a
    // variant whose title contains "Personalized", make it the active cart
    // variant before the studio's ADD_TO_CART reads [data-variant-id].
    if (launchBtn) {
      launchBtn.addEventListener('click', function () {
        if (!variantInput) return;
        for (var pi = 0; pi < variants.length; pi++) {
          if (variants[pi].title.toLowerCase().indexOf('personalized') !== -1) {
            variantInput.value = variants[pi].id;
            return;
          }
        }
      });
    }

    // Deep links from the homepage and collection cards arrive with
    // ?customize=1 — auto-open the studio with full page context. A ?name=
    // alongside it (the Aurora hero's "type their name" box) prefills the
    // name here first, so applyName() carries it into the studio URL.
    try {
      var deep = new URLSearchParams(window.location.search);
      var deepName = (deep.get('name') || '').slice(0, 20);
      if (deepName && nameInput) {
        nameInput.value = deepName;
        applyName();
      }
      if (deep.get('customize') === '1' && launchBtn) {
        applyMode('personalized');
        launchBtn.click();
      }
    } catch (_) {}

  }); // end DOMContentLoaded

  } catch(e) { console.error(e); }
})();
})();
